(function(){
  var THRESHOLD = 200; // حد التوصيل المجاني بالدرهم
  if (!window.Shopify || Shopify.country !== 'AE') return;
  var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
  var rate = parseFloat((Shopify.currency && Shopify.currency.rate) || 1) || 1;
  var cur = (Shopify.currency && Shopify.currency.active) || 'AED';

  function fmt(cents){
    var v = Math.ceil(cents / 100);
    if (cur === 'AED') return ar ? v + ' درهم' : 'AED ' + v;
    return v + ' ' + cur;
  }
  function render(el, total){
    var goal = Math.round(THRESHOLD * rate * 100);
    var left = goal - total;
    var pct = Math.max(0, Math.min(100, Math.round(total / goal * 100)));
    var msg = left > 0
      ? (ar ? 'باقيلك <b>' + fmt(left) + '</b> وبيصير التوصيل مجاني' : 'You\'re <b>' + fmt(left) + '</b> away from free delivery')
      : (ar ? 'مبروك! التوصيل عليك مجاني' : 'You\'ve unlocked free delivery!');    el.innerHTML = '<p class="gl-fs__msg">' + msg + '</p><div class="gl-fs__track"><span style="width:' + pct + '%"></span></div>';
    el.classList.toggle('is-done', left <= 0);
    el.hidden = total <= 0;
  }
  function slot(id, anchor, where){
    if (!anchor) return null;
    var el = document.getElementById(id);
    if (!el){
      el = document.createElement('div');
      el.id = id;
      el.className = 'gl-fs';
      anchor.insertAdjacentElement(where, el);
    }
    return el;
  }
  function update(){
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var a = slot('gl-fs-page', document.querySelector('cart-items .title-wrapper-with-link'), 'afterend');
        var b = slot('gl-fs-notif', document.getElementById('cart-notification-product'), 'afterend');
        [a, b].forEach(function(el){ if (el) render(el, cart.total_price); });
      })
      .catch(function(){});
  }
  function init(){
    update();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
      subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(update, 300); });
    }
    document.addEventListener('submit', function(e){
      if (e.target && e.target.closest && e.target.closest('product-form')) setTimeout(update, 1200);
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* أيقونة السلة جنب السعر بالبطاقات */
(function(){
  function glQaNearPrice(){
    document.querySelectorAll('.product-card-wrapper').forEach(function(w){
      var qa = w.querySelector('.card>.card__content .quick-add');
      var price = w.querySelector('.card-information .price');
      if (qa && price && qa.parentElement !== price){ price.appendChild(qa); price.classList.add('gl-has-qa'); }
    });
  }
  function init(){
    glQaNearPrice();
    new MutationObserver(glQaNearPrice).observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* قائمة الدولة: علم + عملة بس */
(function(){
  function flag(cc){ return 'https://cdn.shopify.com/static/images/flags/' + cc.toLowerCase() + '.svg'; }
  function glFlags(){
    document.querySelectorAll('localization-form').forEach(function(lf){
      var input = lf.querySelector('input[name="country_code"]');
      if (!input) return;
      var btn = lf.querySelector('.disclosure__button');
      var span = btn && btn.querySelector('span');
      if (!span || span.dataset.glDone === input.value) return;
      var cur = (span.textContent.split('|')[1] || '').trim().split(' ')[0];
      btn.setAttribute('title', span.textContent.trim());
      span.innerHTML = '<img class="gl-flag" src="' + flag(input.value) + '" alt="" width="20" height="15"><span class="gl-cur">' + cur + '</span>';
      span.dataset.glDone = input.value;
      lf.querySelectorAll('.country-selector__list a[data-value]').forEach(function(a){
        var c = a.querySelector('.country');
        if (c && !c.querySelector('.gl-flag')) c.insertAdjacentHTML('afterbegin', '<img class="gl-flag" src="' + flag(a.dataset.value) + '" alt="" width="20" height="15">');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', glFlags); else glFlags();
})();


/* كروت المنتجات: نسبة الخصم + AED صغيرة + الكبس على البوكس بيفتح المنتج */
(function(){
  function num(el){ return el ? parseFloat(el.textContent.replace(/[^\d.]/g, '')) : 0; }
  function glCards(){
    document.querySelectorAll('.product-card-wrapper').forEach(function(w){
      w.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function(el){
        if (el.closest('s') || el.querySelector('.gl-cur')) return;
        var m = el.textContent.trim().match(/^([\d.,]+)\s*(AED|د\.إ)$/);
        if (m) el.innerHTML = m[1] + ' <span class="gl-cur">' + m[2] + '</span>';
      });
      var price = w.querySelector('.price--on-sale');
      var badge = w.querySelector('.card__badge .badge');
      if (!price || !badge || badge.dataset.glPct) return;
      var now = num(price.querySelector('.price-item--sale'));
      var was = num(price.querySelector('s.price-item, .price__sale s .price-item--regular'));
      if (!now || !was || was <= now) return;
      badge.textContent = '-' + Math.round((1 - now / was) * 100) + '%';
      badge.dataset.glPct = '1';
    });
  }
  document.addEventListener('click', function(e){
    var w = e.target.closest && e.target.closest('.product-card-wrapper');
    if (!w) return;
    if (e.target.closest('a, button, .quick-add, modal-opener, .Vtl-WishlistIcon__Wrapper, [role="button"]')) return;
    var link = w.querySelector('.card__heading a');
    if (link) window.location.href = link.href;
  });
  function init(){
    glCards();
    var main = document.querySelector('main');
    if (main) new MutationObserver(glCards).observe(main, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* العملة بالعربي: د.إ للإمارات و ر.س للسعودية (بالأسعار بس) */
(function(){
  if ((document.documentElement.lang || '').indexOf('ar') !== 0) return;
  var MAP = { AED: 'د.إ', SAR: 'ر.س' };
  var T = /(AED|SAR)/;
  var ZONES = '.price, .price-item, .gl-cur, .gls, .totals, .cart-item, cart-items, cart-drawer, .cart-notification, #cart-notification, .gl-sa__price, .localization-form, .product__info-container, .cart__footer, [class*="price"]';
  function ok(el){ return el && !/SCRIPT|STYLE|TEXTAREA/.test(el.tagName) && el.closest(ZONES); }
  function fix(root){
    if (!root) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n, list = [];
    while ((n = w.nextNode())){ if (T.test(n.nodeValue) && ok(n.parentElement)) list.push(n); }
    list.forEach(function(n){ n.nodeValue = n.nodeValue.replace(/\b(AED|SAR)\b/g, function(m){ return MAP[m]; }); });
  }
  function init(){
    fix(document.body);
    new MutationObserver(function(ms){
      ms.forEach(function(m){
        if (m.type === 'characterData'){ if (T.test(m.target.nodeValue)) fix(m.target.parentElement); }
        else m.addedNodes.forEach(function(a){
          if (a.nodeType === 1) fix(a);
          else if (a.nodeType === 3 && T.test(a.nodeValue)) fix(a.parentElement);
        });
      });
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* البحث الجديد: اقتراحات + منتجات + إضافة للسلة (عربي وإنجليزي) */
(function(){
  var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AED';
  var L = ar ? {sug:'اقتراحات', prod:'المنتجات', res:'نتيجة', all:'عرض كل النتائج', none:'ما في نتائج لـ', load:'جاري البحث…'}
             : {sug:'Suggestions', prod:'Products', res:'results', all:'View all results', none:'No results for', load:'Searching…'};
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function hl(t, q){
    var i = t.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return esc(t);
    return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + q.length)) + '</mark>' + esc(t.slice(i + q.length));
  }
  function money(c){ return (c / 100).toFixed(2) + ' <span class="gl-cur">' + cur + '</span>'; }
  function img(u){ if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200'; }

  function setup(ps){
    var input = ps.querySelector('input[type="search"]');
    if (!input || input.dataset.gls) return;
    input.dataset.gls = '1';
    ps.querySelectorAll('.gl-ps').forEach(function(b){ b.remove(); });
    var box = document.createElement('div');
    box.className = 'gls';
    box.hidden = true;
    ps.appendChild(box);
    var timer, last = '', ctrl;

    input.addEventListener('input', function(){
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2){ box.hidden = true; box.innerHTML = ''; last = ''; return; }
      timer = setTimeout(function(){ run(q); }, 300);
    });
    input.addEventListener('focus', function(){ if (box.innerHTML) box.hidden = false; });

    box.addEventListener('click', function(e){
      var chip = e.target.closest('.gls__chip');
      if (chip){ e.preventDefault(); input.value = chip.dataset.q; input.dispatchEvent(new Event('input', {bubbles:true})); input.focus(); return; }
      var add = e.target.closest('.gls__add');
      if (add){ e.preventDefault(); addToCart(add); }
    });

    function addToCart(btn){
      if (btn.disabled) return;
      if (btn.dataset.multi === '1'){ window.location.href = btn.dataset.url; return; }
      btn.disabled = true;
      fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id: +btn.dataset.id, quantity:1}], sections:'cart-icon-bubble'})})
        .then(function(r){ return r.json(); })
        .then(function(res){
          if (res.sections && res.sections['cart-icon-bubble']){
            var bubble = document.getElementById('cart-icon-bubble');
            var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
            var src = doc.querySelector('.shopify-section');
            if (bubble && src) bubble.innerHTML = src.innerHTML;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'gl-search'});
          btn.classList.add('is-added');
          setTimeout(function(){ btn.classList.remove('is-added'); btn.disabled = false; }, 1600);
        })
        .catch(function(){ btn.disabled = false; });
    }

    function run(q){
      if (q === last){ box.hidden = false; return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      box.hidden = false;
      box.innerHTML = '<p class="gls__msg">' + L.load + '</p>';
      var url = root + 'search?type=product&options[prefix]=last&q=' + encodeURIComponent(q);
      fetch(url, ctrl ? {signal: ctrl.signal} : {}).then(function(r){ return r.text(); }).then(function(html){
        if (input.value.trim() !== q) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var handles = [], seen = {};
        doc.querySelectorAll('#product-grid a[href*="/products/"], .product-grid a[href*="/products/"]').forEach(function(a){
          var h = a.getAttribute('href').split('?')[0];
          if (!seen[h]){ seen[h] = 1; handles.push(h); }
        });
        var cntEl = doc.querySelector('.product-count__text');
        var total = cntEl ? parseInt(cntEl.textContent.replace(/[^\d]/g, ''), 10) || handles.length : handles.length;
        if (!handles.length){ box.innerHTML = '<p class="gls__msg">' + L.none + ' "' + esc(q) + '"</p>'; return; }
        return Promise.all(handles.slice(0, 6).map(function(h){
          return fetch(h + '.js').then(function(r){ return r.json(); }).catch(function(){ return null; });
        })).then(function(items){
          if (input.value.trim() !== q) return;
          render(q, items.filter(Boolean), total);
        });
      }).catch(function(){});
    }

    function render(q, items, total){
      var types = [];
      items.forEach(function(p){ if (p.type && types.indexOf(p.type) < 0) types.push(p.type); });
      var chips = [];
      types.slice(0, 2).forEach(function(t){ if (t.indexOf(q) < 0) chips.push(q + ' ' + t); });
      types.slice(0, 4).forEach(function(t){ if (chips.length < 4) chips.push(t); });
      var out = '';
      if (chips.length){
        out += '<div class="gls__sec gls__sec--sug"><p class="gls__label">' + L.sug + '</p><div class="gls__chips">';
        chips.forEach(function(c){ out += '<a href="#" class="gls__chip" data-q="' + esc(c) + '"><span class="gls__chip-ico"></span>' + esc(c) + '</a>'; });
        out += '</div></div>';
      }
      out += '<div class="gls__sec"><div class="gls__head"><p class="gls__label">' + L.prod + '</p><span class="gls__count"><b>' + total + '</b> ' + L.res + '</span></div><ul class="gls__list">';
      items.forEach(function(p){
        var v = (p.variants || []).filter(function(x){ return x.available; })[0] || (p.variants || [])[0] || {};
        var multi = (p.variants || []).length > 1 ? '1' : '0';
        var sale = p.compare_at_price && p.compare_at_price > p.price;
        var href = root.replace(/\/$/, '') + '/products/' + p.handle;
        out += '<li class="gls__item"><a class="gls__link" href="' + esc(href) + '">' +
          '<span class="gls__img">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image)) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="gls__txt">' + (ar && p.type ? '<span class="gls__cat">' + esc(p.type) + '</span>' : '') +
          '<span class="gls__title">' + hl(p.title, q) + '</span>' +
          '<span class="gls__price"><span class="gls__now">' + money(p.price) + '</span>' + (sale ? '<s class="gls__was">' + money(p.compare_at_price) + '</s>' : '') + '</span></span></a>' +
          '<button type="button" class="gls__add" aria-label="' + (ar ? 'أضف للسلة' : 'Add to cart') + '" data-id="' + (v.id || '') + '" data-multi="' + multi + '" data-url="' + esc(href) + '"' + (p.available ? '' : ' disabled') + '><span class="gls__add-ico"></span></button></li>';
      });
      out += '</ul></div><div class="gls__foot"><a class="gls__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">' + L.all + ' <span class="gls__badge">' + total + '</span> <span class="gls__arrow">' + (ar ? '←' : '→') + '</span></a></div>';
      box.innerHTML = out;
    }
  }
  function init(){ document.querySelectorAll('predictive-search').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* سحب المجموعات بالماوس بالكمبيوتر */
(function(){
  function init(){
    document.querySelectorAll('.collection-list-wrapper .collection-list').forEach(function(el){
      var down = false, sx = 0, sl = 0, moved = false;
      el.addEventListener('mousedown', function(e){ down = true; moved = false; sx = e.pageX; sl = el.scrollLeft; e.preventDefault(); });
      window.addEventListener('mousemove', function(e){
        if (!down) return;
        var dx = e.pageX - sx;
        if (Math.abs(dx) > 5){ moved = true; el.classList.add('is-drag'); }
        el.scrollLeft = sl - dx;
      });
      window.addEventListener('mouseup', function(){
        if (!down) return;
        down = false;
        setTimeout(function(){ el.classList.remove('is-drag'); }, 0);
      });
      el.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* السحب بالماوس + أسهم يمين ويسار: المجموعات + أقسام المنتجات */
(function(){
  var ICON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  function bounds(el){
    var max = el.scrollWidth - el.clientWidth;
    var rtl = getComputedStyle(el).direction === 'rtl';
    return rtl ? {min: -max, max: 0} : {min: 0, max: max};
  }
  function setup(el){
    if (el.dataset.glDrag) return;
    el.dataset.glDrag = '1';
    el.classList.add('gl-drag');
    /* السحب */
    var down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('mousedown', function(e){
      if (e.button !== 0 || e.target.closest('button, .Vtl-WishlistIcon__Wrapper')) return;
      down = true; moved = false; sx = e.pageX; sl = el.scrollLeft; e.preventDefault();
    });
    window.addEventListener('mousemove', function(e){
      if (!down) return;
      var dx = e.pageX - sx;
      if (Math.abs(dx) > 5){ moved = true; el.classList.add('is-drag'); }
      el.scrollLeft = sl - dx;
    });
    window.addEventListener('mouseup', function(){
      if (!down) return;
      down = false;
      setTimeout(function(){ el.classList.remove('is-drag'); }, 0);
    });
    el.addEventListener('click', function(e){ if (moved){ e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    /* الأسهم */
    var host = el.parentElement;
    host.classList.add('gl-arrows-host');
    var left = document.createElement('button');
    var right = document.createElement('button');
    left.type = right.type = 'button';
    left.className = 'gl-arrow gl-arrow--left';
    right.className = 'gl-arrow gl-arrow--right';
    left.setAttribute('aria-label', 'Scroll left');
    right.setAttribute('aria-label', 'Scroll right');
    left.innerHTML = ICON_L;
    right.innerHTML = ICON_R;
    host.appendChild(left);
    host.appendChild(right);
    function step(){ var li = el.children[0]; return li ? (li.getBoundingClientRect().width + 16) * 2 : el.clientWidth / 2; }
    left.addEventListener('click', function(){ el.scrollBy({left: -step(), behavior: 'smooth'}); });
    right.addEventListener('click', function(){ el.scrollBy({left: step(), behavior: 'smooth'}); });
    function update(){
      var b = bounds(el);
      var h = host.getBoundingClientRect(), g = el.getBoundingClientRect();
      var off = window.innerWidth >= 1200 ? -22 : 6;
      host.style.setProperty('--gl-al', (g.left - h.left + off) + 'px');
      host.style.setProperty('--gl-ar', (h.right - g.right + off) + 'px');
      var item = el.children[0];
      if (item){
        var r = item.getBoundingClientRect();
        host.style.setProperty('--gl-arrow-top', (r.top - h.top + r.height / 2) + 'px');
      }
            left.hidden = !(el.scrollLeft > b.min + 2);
      right.hidden = !(el.scrollLeft < b.max - 2);
    }
    el.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 800);
  }
  function init(){
    document.querySelectorAll('.collection-list-wrapper .collection-list, .collection slider-component .product-grid').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* شريط التنقل السفلي بالموبايل: بيطلع لما يختفي الهيدر */
(function(){
  if (/\/products\//.test(location.pathname)) return;
  var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var T = ar ? ['الرئيسية','المجموعات','السلة','حسابي'] : ['Home','Collections','Cart','Account'];
  var I = {
    home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z"/></svg>',
    grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><rect x="3.5" y="3.5" width="7" height="7" rx="2"/><rect x="13.5" y="3.5" width="7" height="7" rx="2"/><rect x="3.5" y="13.5" width="7" height="7" rx="2"/><rect x="13.5" y="13.5" width="7" height="7" rx="2"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L21 8H6.2"/><circle cx="9.5" cy="19.5" r="1.3"/><circle cx="17" cy="19.5" r="1.3"/></svg>',
    user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="8" r="4"/><path d="M4.5 20.5c1.4-3.6 4.3-5.5 7.5-5.5s6.1 1.9 7.5 5.5"/></svg>'
  };
  function init(){
    if (document.querySelector('.gl-bn')) return;
    var acc = document.querySelector('.header__icon--account');
    var links = [
      [root, I.home, T[0], 'home'],
      [root.replace(/\/?$/, '/') + 'collections', I.grid, T[1], 'col'],
      [root.replace(/\/?$/, '/') + 'cart', I.cart, T[2], 'cart'],
      [acc ? acc.getAttribute('href') : root.replace(/\/?$/, '/') + 'account', I.user, T[3], 'acc']
    ];
    var p = location.pathname.replace(/\/$/, '') || '/';
    var r = root.replace(/\/$/, '') || '/';
    function active(k){
      if (k === 'home') return p === r;
      if (k === 'col') return /\/collections(\/|$)/.test(p);
      if (k === 'cart') return /\/cart$/.test(p);
      if (k === 'acc') return /\/account/.test(p);
    }
    var nav = document.createElement('nav');
    nav.className = 'gl-bn';
    nav.setAttribute('aria-label', ar ? 'التنقل' : 'Navigation');
    nav.innerHTML = links.map(function(l){
      return '<a class="gl-bn__i' + (active(l[3]) ? ' is-on' : '') + '" href="' + l[0] + '"' + (l[3] === 'acc' ? ' rel="nofollow"' : '') + '>' +
        '<span class="gl-bn__ic">' + l[1] + (l[3] === 'cart' ? '<b class="gl-bn__n" hidden></b>' : '') + '</span>' +
        '<span class="gl-bn__t">' + l[2] + '</span></a>';
    }).join('');
    document.body.appendChild(nav);
    var n = nav.querySelector('.gl-bn__n');
    function count(){
      var s = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
      var v = s ? s.textContent.trim() : '';
      n.textContent = v; n.hidden = !v || v === '0';
    }
    count();
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) new MutationObserver(count).observe(bubble, {childList:true, subtree:true, characterData:true});
    var head = document.querySelector('.section-header');
    var ticking = false;
    function check(){
      ticking = false;
      var hidden = head ? (head.classList.contains('shopify-section-header-hidden') || head.getBoundingClientRect().bottom <= 0) : window.scrollY > 200;
      document.body.classList.toggle('gl-bn-on', hidden && window.scrollY > 120);
    }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(check); } }, {passive:true});
    if (head) new MutationObserver(check).observe(head, {attributes:true, attributeFilter:['class']});
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* لون شريط المتصفح بالموبايل بيتغير مع الهيدر */
(function(){
  function init(){
    var m = document.querySelector('meta[name="theme-color"]');
    if (!m){ m = document.createElement('meta'); m.name = 'theme-color'; document.head.appendChild(m); }
    var bar = document.querySelector('.utility-bar');
    var head = document.querySelector('.section-header');
    var ticking = false;
    function set(){
      ticking = false;
      var c = '#ffffff';
      if (bar && bar.getBoundingClientRect().bottom > 0) c = '#9969c7';
      else if (head && !head.classList.contains('shopify-section-header-hidden') && head.getBoundingClientRect().bottom > 0) c = '#e6e6e6';
      if (m.content !== c) m.content = c;
    }
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(set); } }, {passive:true});
    if (head) new MutationObserver(set).observe(head, {attributes:true, attributeFilter:['class']});
    set();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* صفحة السلة: تصميم جديد (كروت المنتجات + ملخص الطلب) */
(function(){
  if (!/\/cart\/?$/.test(location.pathname)) return;
  var ar = (document.documentElement.lang || '').indexOf('ar') === 0;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var L = ar ? {
    sum: 'ملخص الطلب', code: 'إضافة كود خصم', ph: 'اكتب كود الخصم', apply: 'تطبيق',
    sub: 'المجموع', ship: 'الشحن', free: 'مجاني', later: 'يُحسب عند الدفع', total: 'الإجمالي',
    cont: 'متابعة التسوق', bad: 'الكود غير صالح', rm: 'إزالة'
  } : {
    sum: 'Order summary', code: 'Add discount code', ph: 'Enter discount code', apply: 'Apply',
    sub: 'Subtotal', ship: 'Shipping', free: 'Free', later: 'Calculated at checkout', total: 'Total',
    cont: 'Continue shopping', bad: 'Invalid code', rm: 'Remove'
  };
  var CHEV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>';
  function money(c, cur){ return (c / 100).toFixed(2) + ' ' + cur; }

  function init(){
    var itemsSec = document.querySelector('[id$="__cart-items"]');
    var footSec = document.querySelector('[id$="__cart-footer"]');
    if (!itemsSec || !footSec || document.querySelector('.gl-cart')) return;
    document.body.classList.add('gl-cartpage');

    var wrap = document.createElement('div');
    wrap.className = 'gl-cart page-width';
    itemsSec.parentNode.insertBefore(wrap, itemsSec);
    var head = itemsSec.querySelector('.title-wrapper-with-link');
    if (head){
      var ph = document.createElement('div');
      ph.className = 'title-wrapper-with-link';
      ph.hidden = true;
      head.parentNode.insertBefore(ph, head);
      head.classList.add('gl-cart__head');
      wrap.appendChild(head);
    }
    wrap.appendChild(itemsSec);
    wrap.appendChild(footSec);

    var blocks = footSec.querySelector('.cart__blocks');
    var jsc = blocks && blocks.querySelector('.js-contents');
    var ctas = footSec.querySelector('.cart__ctas');
    if (!blocks || !jsc) return;

    var top = document.createElement('div');
    top.className = 'gl-sum';
    top.innerHTML =
      '<h2 class="gl-sum__t">' + L.sum + '</h2>' +
      '<button type="button" class="gl-sum__code" aria-expanded="false">' + L.code + CHEV + '</button>' +
      '<div class="gl-sum__form" hidden><input type="text" autocomplete="off" placeholder="' + L.ph + '"><button type="button">' + L.apply + '</button></div>' +
      '<p class="gl-sum__msg" hidden></p>' +
      '<div class="gl-sum__applied"></div>' +
      '<div class="gl-sum__rows">' +
        '<div class="gl-sum__row"><span>' + L.sub + '</span><b class="gl-sum__sub"></b></div>' +
        '<div class="gl-sum__row"><span>' + L.ship + '</span><b class="gl-sum__ship"></b></div>' +
      '</div>' +
      '<div class="gl-sum__row gl-sum__total"><span>' + L.total + '</span><b class="gl-sum__tot"></b></div>';
    blocks.insertBefore(top, jsc);

    var tgl = top.querySelector('.gl-sum__code');
    var form = top.querySelector('.gl-sum__form');
    var inp = form.querySelector('input');
    var msg = top.querySelector('.gl-sum__msg');
    tgl.addEventListener('click', function(){
      var open = form.hidden;
      form.hidden = !open;
      tgl.setAttribute('aria-expanded', open);
      if (open) inp.focus();
    });
    function setCodes(codes){
      return fetch(root.replace(/\/?$/, '/') + 'cart/update.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({discount: codes.join(',')})
      }).then(function(r){ return r.json(); });
    }
    function apply(){
      var code = inp.value.trim();
      if (!code) return;
      var cur = (window.__glCodes || []).filter(function(c){ return c.toLowerCase() !== code.toLowerCase(); });
      setCodes(cur.concat(code)).then(function(c){
        var hit = (c.discount_codes || []).filter(function(d){ return d.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable){ location.reload(); }
        else {
          msg.textContent = L.bad; msg.hidden = false; msg.className = 'gl-sum__msg is-bad';
          setCodes(cur);
        }
      });
    }
    form.querySelector('button').addEventListener('click', apply);
    inp.addEventListener('keydown', function(e){ if (e.key === 'Enter'){ e.preventDefault(); apply(); } });

    if (ctas && !ctas.querySelector('.gl-sum__cont')){
      var cont = document.createElement('a');
      cont.className = 'gl-sum__cont';
      cont.href = root.replace(/\/?$/, '/') + 'collections/all';
      cont.textContent = L.cont;
      ctas.insertBefore(cont, ctas.firstChild);
    }

    var pay = document.createElement('div');
    pay.className = 'gl-sum__pay';
    blocks.parentNode.appendChild(pay);
    var src = document.querySelector('.tpt-footer-1_payment-icons');
    if (src) pay.innerHTML = src.innerHTML;
    else {
      var sid = document.querySelector('[id*="tpt_footer"]');
      var id = sid ? sid.id.replace('shopify-section-', '') : 'template--28092592947443__tpt_footer_1_jYyQYM';
      fetch(root.replace(/\/?$/, '/') + '?section_id=' + id).then(function(r){ return r.text(); }).then(function(h){
        var d = new DOMParser().parseFromString(h, 'text/html');
        var s = d.querySelector('.tpt-footer-1_payment-icons');
        if (s) pay.innerHTML = s.innerHTML;
      }).catch(function(){});
    }

    /* سعر الشحن: الإمارات افتراضياً، والسعودية لزبائن السعودية */
    var COUNTRY = (window.Shopify && Shopify.country === 'SA') ? 'Saudi Arabia' : 'United Arab Emirates';
    var PROV = COUNTRY === 'Saudi Arabia' ? 'Riyadh' : 'Dubai';
    function shipRate(){
      var q = 'shipping_address[country]=' + encodeURIComponent(COUNTRY) + '&shipping_address[province]=' + PROV + '&shipping_address[zip]=00000';
      var base = root.replace(/\/?$/, '/') + 'cart/';
      return fetch(base + 'prepare_shipping_rates.json?' + q, {method: 'POST'}).then(function(){
        var n = 0;
        return new Promise(function(res){
          (function poll(){
            fetch(base + 'async_shipping_rates.json?' + q).then(function(r){ return r.status === 200 ? r.json() : null; }).then(function(j){
              if (j && j.shipping_rates){
                var p = j.shipping_rates.map(function(x){ return Math.round(parseFloat(x.price) * 100); });
                res(p.length ? Math.min.apply(null, p) : null);
              } else if (++n < 10) setTimeout(poll, 700);
              else res(null);
            }).catch(function(){ res(null); });
          })();
        });
      }).catch(function(){ return null; });
    }
    var busy = false, again = false;
    function refresh(){
      if (busy){ again = true; return; } busy = true;
      fetch(root.replace(/\/?$/, '/') + 'cart.js').then(function(r){ return r.json(); }).then(function(c){
        window.__glCodes = (c.discount_codes || []).filter(function(d){ return d.applicable; }).map(function(d){ return d.code; });
        top.querySelector('.gl-sum__sub').textContent = money(c.items_subtotal_price, c.currency);
        top.querySelector('.gl-sum__applied').innerHTML = window.__glCodes.map(function(code){
          return '<span class="gl-sum__chip">' + code.replace(/</g, '&lt;') + '<button type="button" data-code="' + code.replace(/"/g, '&quot;') + '" aria-label="' + L.rm + '">×</button></span>';
        }).join('');
        var sh = top.querySelector('.gl-sum__ship'), tot = top.querySelector('.gl-sum__tot');
        if (!c.item_count){ busy = false; return; }
        return shipRate().then(function(rate){
          busy = false;
          sh.classList.remove('is-free', 'is-later');
          if (rate === null){ sh.textContent = L.later; sh.classList.add('is-later'); tot.textContent = money(c.total_price, c.currency); }
          else if (rate === 0){ sh.textContent = L.free; sh.classList.add('is-free'); tot.textContent = money(c.total_price, c.currency); }
          else { sh.textContent = money(rate, c.currency); tot.textContent = money(c.total_price + rate, c.currency); }
          if (again){ again = false; refresh(); }
        });
      }).catch(function(){ busy = false; });
    }
    top.addEventListener('click', function(e){
      var b = e.target.closest('.gl-sum__chip button');
      if (!b) return;
      var left = (window.__glCodes || []).filter(function(c){ return c !== b.dataset.code; });
      setCodes(left).then(function(){ location.reload(); });
    });
    refresh();
    new MutationObserver(function(){ setTimeout(refresh, 50); }).observe(jsc, {childList: true, subtree: true, characterData: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();